import Image from 'next/image'
import React, { useContext } from 'react'
import { AnimatePresence, motion } from "framer-motion";
import { BASE_URL } from '../../utils/FetchData';
import { isMobileContext } from '../../contexts/isMobileContext';
import Button from '../common/Button';
import { useTranslation } from 'next-i18next';
const ServicesCard = ({ cardData, index }) => {
    const { isMobile } = useContext(isMobileContext);
		const { t } = useTranslation("common");
 
    return (
            <div className='services-card _eleX'>
                <div className='img-container'>
                    {cardData?.Img_Mobile?.data?.attributes?.url?<Image
                        src={`${BASE_URL}${isMobile ? cardData?.Img_Mobile?.data?.attributes?.url : cardData?.Img_Desktop?.data?.attributes?.url}`}
                        alt={isMobile ? cardData?.Img_Mobile?.data?.attributes?.name : cardData?.Img_Desktop?.data?.attributes?.name}
                        objectFit="cover"
                        layout="fill"
                        />:""
                    }
                    <div className="overlay"></div>
                {cardData?.pdf?.data?.attributes?.url &&
                <a 
                    className="downloadBtn" aria-label="pdf" target="_blank" rel="noopener noreferrer"
                                href={BASE_URL + cardData?.pdf?.data?.attributes?.url}
                            >
                                <Button text={t("common.explore_more")}  />
                            </a>
                } 
                </div>
                <div className='title'>
                    <span>{cardData?.Title}</span>
                </div>
                <div className='description'>
                    <p>{cardData?.Description}</p>
                </div>
            </div>
    )
}

export default ServicesCard